import { graphql } from 'react-relay';
import sortBy from 'lodash/sortBy';
import {
  GraphQLReturn,
  graphQLSelector,
  Writeable,
} from '@cherre-frontend/data-fetching';
import { DbSysPropertyTypesIds } from 'src/const';
import {
  type CustomPropertyAttribute,
  type CustomPropertyAttributeJson,
  CustomPropertyAttributeType,
} from '../../../types/CustomPropertyAttribute';
import { getPropertyTypeCustomAttributesQuery } from './__generated__/getPropertyTypeCustomAttributesQuery.graphql';

interface CustomAttributesResponse {
  property_type_id: number;
  custom_attributes: CustomPropertyAttributeJson[];
}

const { INVESTMENT } = DbSysPropertyTypesIds;

export const getPropertyTypeCustomAttributes = graphQLSelector({
  query: graphql`
    query getPropertyTypeCustomAttributesQuery {
      sys_property_type_custom_attributes {
        property_type_id
        custom_attributes
      }
    }
  ` as GraphQLReturn<getPropertyTypeCustomAttributesQuery>,
  mapVariables: () => () => ({}),
  mapResponse: (response) => {
    const propertyTypeCustomAttributes: Writeable<CustomAttributesResponse[]> =
      response.sys_property_type_custom_attributes ?? [];

    const attributes: CustomPropertyAttribute[] = propertyTypeCustomAttributes
      .filter(({ custom_attributes }) => (custom_attributes || []).length > 0)
      .flatMap(({ custom_attributes, property_type_id }) =>
        custom_attributes.map((attribute, index) => ({
          ...attribute,
          propertyTypeId: property_type_id,
          isTargetPropertyType: property_type_id === INVESTMENT,
          order: attribute.order ?? index,
          active: attribute.active ?? true,
          required: attribute.required ?? false,
          type: attribute.type ?? CustomPropertyAttributeType.STRING,
        }))
      );

    return sortBy(attributes, 'order');
  },
});
